<kt-portlet class="edit-doctor-div">
  <kt-portlet-header
    [title]="getTitle()"
    class="cards-inside-doctor-form card-head-lg card-head"
    [viewLoading$]="loading$"
  >
  
    <ng-container ktPortletTools>
      <a
        ktBackButton
        class="btn btn-secondary mr-2"
        mat-raised-button
        matTooltip="Back to the drugGroups list"
      >
        <i class="la la-arrow-left"></i>
        <span class="hidden-mobile" translate="GLOBAL.BACK">Back</span>
      </a>
      <ng-template ngxPermissionsOnly="canEditDrugGroup">
        <a
          *ngIf="isViewMode"
          (click)="editDrugGroup(drugGroup.id)"
          class="btn btn-secondary mr-2"
          mat-raised-button
          matTooltip="Back to the drugGroups list"
        >
          <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
        </a>
      </ng-template>
      <a
        *ngIf="!isViewMode && drugGroup && !drugGroup.id"
        href="javascript:;"
        class="btn btn-secondary mr-2"
        (click)="reset()"
        mat-raised-button
        matTooltip="Reset changes"
      >
        <i class="la la-cog"></i>
        <span class="hidden-mobile" translate="GLOBAL.RESET">Reset</span>
      </a>
      <a
        *ngIf="!isViewMode"
        href="javascript:;"
        class="btn btn-primary mr-2"
        color="primary"
        (click)="onSumbit(false)"
        mat-raised-button
        matTooltip="Save & Continue"
      >
        <span class="hidden-mobile" translate="GLOBAL.SAVE">Save</span>
      </a>
    </ng-container>
  </kt-portlet-header>
  <div *ngIf="drugGroup">
    <!--begin::Form-->
    <form [formGroup]="drugGroupForm" class="form form-group-seperator-dashed">
      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [showCloseButton]="true"
        [duration]="10000"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"
          >Oh snap! Change a few things up and try submitting again.</span
        >
      </kt-alert>
      <div class="form-section form-section-first whole-form">
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4 translate="DRUG_GROUP.FORM.DRUG_GROUP_DETAILS">Drug Group Details</h4>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG_GROUP.FORM.NAME">Name</mat-label>
              <input matInput formControlName="name" required />
              <mat-error *ngIf="isControlHasError('name', 'required')">
                Name is
                <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG_GROUP.FORM.COPAY_ASSISTANCE">Copay Assistance</mat-label>
              <input matInput formControlName="copay_assistance" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG_GROUP.FORM.COPAY_ASSISTANCE_URL"
                >Copay Assistance URL</mat-label
              >
              <input matInput formControlName="copay_assistance_url" />
              <mat-error *ngIf="isControlHasError('copay_assistance_url', 'required')">
                Copay Assistance URL is
                <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3 kt-margin-bottom-20-mobile">
            <div class="mat-form-field-fluid">
              <mat-label class="row ml-1" translate="DRUG_GROUP.FORM.DRUG_GROUP_STATUS"
                >Drug Group Status</mat-label
              >
              <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
              <mat-hint align="start">
                <strong>{{ getStatusString() }}</strong>
              </mat-hint>
            </div>
          </div>
        </div>
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4 translate="DRUG_GROUP.FORM.OTHER">Other</h4>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG_GROUP.FORM.NOTE">Note</mat-label>
              <textarea matInput rows="7" formControlName="note"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--end::Form-->
</kt-portlet>
